export default __webpack_public_path__ + "static/char-s-20-ja-6a8886ad475d861118cedcf9d4ce9982.webp";